import { render, staticRenderFns } from "./EnterpriseSportComp.vue?vue&type=template&id=61db6f18&scoped=true"
import script from "./EnterpriseSportComp.vue?vue&type=script&lang=js"
export * from "./EnterpriseSportComp.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseSportComp.vue?vue&type=style&index=0&id=61db6f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db6f18",
  null
  
)

/* custom blocks */
import block0 from "./EnterpriseSportComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports